// export const Button = ({
//   children,
//   variant = 'primary',
//   size = 'md',
//   loading = false,
//   disabled = false,
//   onClick,
//   className = '',
//   ...props
// }) => {
//   const baseStyles = 'font-semibold rounded-lg transition-colors duration-200'
//
//   const variants = {
//     primary: 'bg-blue-600 text-white hover:bg-blue-700 disabled:bg-blue-400',
//     secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 disabled:bg-gray-100',
//     danger: 'bg-red-600 text-white hover:bg-red-700 disabled:bg-red-400',
//     success: 'bg-green-600 text-white hover:bg-green-700 disabled:bg-green-400',
//     outline: 'border-2 border-blue-600 text-blue-600 hover:bg-blue-50 disabled:border-blue-400',
//   }
//
//   const sizes = {
//     sm: 'px-3 py-1 text-sm',
//     md: 'px-4 py-2 text-base',
//     lg: 'px-6 py-3 text-lg',
//   }
//
//   return (
//     <button
//       className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
//       onClick={onClick}
//       disabled={loading || disabled}
//       {...props}
//     >
//       {loading ? (
//         <span className="flex items-center gap-2">
//           <span className="animate-spin">⚙️</span>
//           Загрузка...
//         </span>
//       ) : (
//         children
//       )}
//     </button>
//   )
// }

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  onClick,
  className = '',
  ...props
}) => {
  const baseStyles = 'font-semibold rounded-lg transition-colors duration-200 inline-flex items-center justify-center'

  const variants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 disabled:bg-blue-400',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 disabled:bg-gray-100',
    danger: 'bg-red-600 text-white hover:bg-red-700 disabled:bg-red-400',
    success: 'bg-green-600 text-white hover:bg-green-700 disabled:bg-green-400',
    outline: 'border-2 border-blue-600 text-blue-600 hover:bg-blue-50 disabled:border-blue-400',
  }

  const sizes = {
    sm: 'px-2 md:px-3 py-1 md:py-2 text-xs md:text-sm',
    md: 'px-3 md:px-4 py-2 md:py-2 text-sm md:text-base',
    lg: 'px-4 md:px-6 py-2 md:py-3 text-base md:text-lg',
  }

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      onClick={onClick}
      disabled={loading || disabled}
      {...props}
    >
      {loading ? (
        <span className="flex items-center gap-2">
          <span className="animate-spin">⚙️</span>
          <span className="hidden sm:inline">Загрузка...</span>
        </span>
      ) : (
        children
      )}
    </button>
  )
}
